import { EMPTY_OBJECT } from '../../../../../constants/common'
import { DATE_FULL_FORMAT } from '../../../../../constants/date'
import { formatNumberWithSeparators } from '../../../../../utils/number'
import { formatDate, TableStatusCell, TableTextCell } from '../../../../Table'
import {
  IMPORT_RUN_COLUMN_NAME,
  IMPORT_RUN_STATUSES,
} from '../IntegrationsImportLog.constants'
import { getIsImportRunCountAlarming } from '../IntegrationsImportLog.utils'

function renderImportRunCount({ className, count, ...restProps }) {
  return (
    <TableTextCell
      {...restProps}
      textCellProps={
        getIsImportRunCountAlarming(count) ? { className } : EMPTY_OBJECT
      }
      value={formatNumberWithSeparators(count)}
    />
  )
}

export function renderImportRunCell({
  blockedClassName,
  heldClassName,
  item,
  locale,
  name,
  timezone,
  ...restProps
}) {
  switch (name) {
    case IMPORT_RUN_COLUMN_NAME.Started:
      return (
        <TableTextCell
          {...restProps}
          value={formatDate({
            date: item.started_at,
            dateFormat: DATE_FULL_FORMAT,
            locale,
            timezone,
            useTodayFormat: false,
          })}
        />
      )

    case IMPORT_RUN_COLUMN_NAME.Source:
      return <TableTextCell {...restProps} value={item.source_label} />

    case IMPORT_RUN_COLUMN_NAME.Status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={IMPORT_RUN_STATUSES}
          value={item.status}
        />
      )

    case IMPORT_RUN_COLUMN_NAME.Records:
      return (
        <TableTextCell
          {...restProps}
          value={formatNumberWithSeparators(item.records_received)}
        />
      )

    case IMPORT_RUN_COLUMN_NAME.Applied:
      return (
        <TableTextCell
          {...restProps}
          value={formatNumberWithSeparators(item.fields_applied)}
        />
      )

    case IMPORT_RUN_COLUMN_NAME.Blocked:
      return renderImportRunCount({
        ...restProps,
        className: blockedClassName,
        count: item.fields_blocked,
      })

    case IMPORT_RUN_COLUMN_NAME.Held:
      return renderImportRunCount({
        ...restProps,
        className: heldClassName,
        count: item.fields_held,
      })

    default:
      return null
  }
}
